import { render, staticRenderFns } from "./machineries.vue?vue&type=template&id=63c6b00c"
import script from "./machineries.vue?vue&type=script&lang=js"
export * from "./machineries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports